import { Button } from '../../ui/Button/Button';
import { H1 } from '../../ui/H1/H1';
import Icon from '../Icon/Icon';
import TimeSelection from './TimeSelection';
import S from './ToolbarStyles';
import { Props } from './types';

function Toolbar({
  title,
  buttons,
  timeSelection,
  allTimeOption,
  customTimeBlocked,
  filters,
  setFilters,
}: Props): JSX.Element {
  return (
    <S.Wrapper>
      <H1> { title } </H1>
      { timeSelection && <TimeSelection filters={filters} setFilters={setFilters} allTimeOption={allTimeOption} customTimeBlocked={customTimeBlocked} />}
      { timeSelection && buttons && <S.VerticalDivider /> }
      {buttons && buttons.filter((button) => !button.hide).map((button) => (
        <Button
          key={button.title}
          background={button.background}
          hoverBackground={button.hoverBackground}
          hoverColor={button.hoverColor}
          onClick={button.action}
          padding={button.padding}
          textColor={button.textColor}
          disabled={button.disabled !== undefined ? button.disabled : false}
        >
          {button.iconKey && <Icon iconKey={button.iconKey} />}
          <p> {button.title} </p>
        </Button>
      )) }
    </S.Wrapper>
  );
}

export default Toolbar;
